var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"show-photos-link",attrs:{"href":`${_vm.mainTopCatUrl}${_vm.albumUrl}`,"target":"_blank"}},[_c('div',{staticClass:"link-text"},[_vm._v(" Посмотреть фотоотчет ")]),_vm._l((_vm.showPhotos),function(photo,index){return _c('div',{key:index,staticClass:"show-photos"},[_c('img',{attrs:{"src":photo.thumb_src}})])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }